import React, { Children } from 'react';
import { motion } from 'framer-motion';
const ESSAYS = [{
  id: 1,
  title: 'The End of the Cable Bundle for Live Sports',
  byline: 'David Chen',
  date: 'Oct 22, 2023',
  readTime: '14 min',
  image: 'https://images.unsplash.com/photo-1486218119243-13883505764c?q=80&w=1000&auto=format&fit=crop'
}, {
  id: 2,
  title: 'The Unbundling of the Sports Newsroom',
  byline: 'Sarah Jenkins',
  date: 'Oct 20, 2023',
  readTime: '11 min',
  image: 'https://images.unsplash.com/photo-1504450758481-7338eba7524a?q=80&w=1000&auto=format&fit=crop'
}, {
  id: 3,
  title: 'Why Stadium Tech Is Suddenly the Hottest VC Bet',
  byline: 'Elena Rostova',
  date: 'Oct 18, 2023',
  readTime: '9 min',
  image: 'https://images.unsplash.com/photo-1471295253337-3ceaaedca402?q=80&w=1000&auto=format&fit=crop'
}, {
  id: 4,
  title: 'The Rise of the Athlete-Operator',
  byline: 'Marcus Chen',
  date: 'Oct 15, 2023',
  readTime: '12 min',
  image: 'https://images.unsplash.com/photo-1546519638-68e109498ffc?q=80&w=1000&auto=format&fit=crop'
}, {
  id: 5,
  title: 'Stadium Real Estate in the Age of Mixed-Use Districts',
  byline: 'David Chen',
  date: 'Oct 12, 2023',
  readTime: '15 min',
  image: 'https://images.unsplash.com/photo-1551958219-acbc608c6377?q=80&w=1000&auto=format&fit=crop'
}, {
  id: 6,
  title: "Private Equity's Quiet Takeover of European Football",
  byline: 'Sarah Jenkins',
  date: 'Oct 10, 2023',
  readTime: '10 min',
  image: 'https://images.unsplash.com/photo-1508098682722-e99c43a406b2?q=80&w=1000&auto=format&fit=crop'
}];
const container = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const item = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function ArticleGrid() {
  return <section id="essays" className="max-w-[96rem] mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24 border-thick-b" data-id="element-10">
      <div className="flex flex-col md:flex-row md:justify-between md:items-end mb-16 gap-6" data-id="element-11">
        <div data-id="element-12">
          <span className="kicker-block mb-6" data-id="element-13">Long-form</span>
          <h2 className="font-serif text-7xl sm:text-8xl lg:text-9xl font-black tracking-tighter uppercase leading-none" data-id="element-14">
            Essays
          </h2>
        </div>
        <a href="#" className="font-mono text-base font-black uppercase tracking-widest text-ink hover:text-accent transition-colors border-b-4 border-ink hover:border-accent pb-1 inline-block self-start md:self-auto mb-2" data-id="element-15">
          All Essays →
        </a>
      </div>

      <motion.div variants={container} initial="hidden" whileInView="show" viewport={{
      once: true,
      margin: '-50px'
    }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-16" data-id="element-16">
        {ESSAYS.map(article => <motion.article key={article.id} variants={item} className="group cursor-pointer flex flex-col h-full" data-id="element-17">
            <div className="aspect-[3/2] overflow-hidden mb-6 bg-ink border-2 border-ink" data-id="element-18">
              <img src={article.image} alt={article.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105 grayscale hover:grayscale-0" data-id="element-19" />
            </div>
            <h3 className="font-serif text-3xl sm:text-4xl leading-[0.95] font-black mb-4 group-hover:text-accent transition-colors tracking-tight" data-id="element-20">
              {article.title}
            </h3>
            <div className="mt-auto pt-4 flex flex-wrap items-center gap-x-2 gap-y-1 font-mono text-xs uppercase tracking-widest text-ink border-t-2 border-ink" data-id="element-21">
              <span className="font-black" data-id="element-22">{article.byline}</span>
              <span className="font-black" data-id="element-23">/</span>
              <span className="font-bold" data-id="element-24">{article.date}</span>
              <span className="font-black" data-id="element-25">/</span>
              <span className="font-bold" data-id="element-26">{article.readTime}</span>
            </div>
          </motion.article>)}
      </motion.div>
    </section>;
}